import { motion } from 'framer-motion';
import { styled } from 'styled-components';

export const Row = styled.div`
    display: grid;
    grid-template-columns: 2.7fr 1fr 1fr 1fr minmax(130px, 1fr) 110px;
    gap: 20px;

    width: fit-content;
    min-width: 100%;
    min-height: 40px;

    border-radius: 10px;
    background: rgba(255, 255, 255, 0.05);
    padding: 5px 0px;
    position: relative;

    @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
        padding: 15px 15px 0;
        gap: 0;
        width: 100%;
    }
`;

export const Cell = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 100px;

    @media (max-width: 768px) {
        min-width: unset;
    }
`;

export const InfoCell = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 220px;
    position: relative;

    background-color: #161425;
    position: sticky;
    left: 0px;

    padding-left: 12px;

    border-radius: 10px 0px 0px 10px;

    @media (max-width: 768px) {
        padding: 0;
        min-width: unset;
        width: 100%;
        overflow: hidden;
    }
`;

export const Subtext = styled.div`
    color: rgba(255, 255, 255, 0.5);
    font-size: 12px;
    font-weight: 600;
    line-height: 130%;
    letter-spacing: -0.24px;
    white-space: nowrap;
`;

export const ToggleArea = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 15px;
    gap: 15px;
`;

export const ExpandedData = styled(motion.div)`
    overflow: hidden;
`;

export const ExpandedInside = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;

    padding: 15px 0;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
`;

export const DataRow = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
`;

export const DataLabel = styled.div`
    color: rgba(255, 255, 255, 0.5);
    font-size: 12px;
    font-weight: 600;
    line-height: 130%;
    letter-spacing: -0.24px;
`;

export const MobileClickCover = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 28px;
    right: 0;
`;
